import { useMutation } from "@tanstack/react-query";
import { API_URL } from "src/Utils/API";
import { DeleteStaffResult } from "../types/staff";

// DELETE /web/admin/staff?email={email} — Admin only.
// The /web/admin/** endpoints return raw DTOs (no ApiResponse envelope) and
// respond with 404 when no staff member matches the email.
export const useDeleteAdminStaff = (
  onSuccess?: (result: DeleteStaffResult) => void,
) =>
  useMutation({
    mutationFn: async (email: string): Promise<DeleteStaffResult> => {
      const params = new URLSearchParams({ email });
      const res = await fetch(`${API_URL}/admin/staff?${params}`, {
        method: "DELETE",
        credentials: "include",
      });
      if (res.status === 404) {
        throw new Error("No staff member found for that email.");
      }
      if (!res.ok) {
        throw new Error("Failed to delete staff member.");
      }
      return (await res.json()) as DeleteStaffResult;
    },
    onSuccess,
  });
